import { Caption, Grid } from '@design-systems/canvas-ui'
import AccountCard from './AccountCard'
import { CalendarIcon } from '@design-systems/react-icons'
import { useEffect } from 'react'
import { useWatch, type Control, type UseFormSetValue } from 'react-hook-form'
import ControlledFormField from 'components/form/ControlledFormField'
import { AccountSettingsInputs } from 'account/types'
import { characterCount } from '@plm-core/utils'

type Props = {
  control: Control<AccountSettingsInputs>
  setValue: UseFormSetValue<AccountSettingsInputs>
}

export const AvailabilityCard = ({ control, setValue }: Props) => {
  const currentUserOutOfOffice = useWatch({ control, name: 'userOutOfOffice' })

  useEffect(() => {
    if (!currentUserOutOfOffice) {
      setValue('oooMessage', '', { shouldDirty: true })
      setValue('oooFromDate', '', { shouldDirty: true })
      setValue('oooToDate', '', { shouldDirty: true })
    }
  }, [currentUserOutOfOffice, setValue])

  return (
    <AccountCard
      svg={CalendarIcon}
      cardHeading="Availability"
      cardSubheading="Set your availability status."
    >
      <Grid.Container spacing="expanded">
        <Grid.Item size={{ xs: 12 }}>
          <Caption below="Add dates and an optional message so teammates know when you are away.">
            <strong>Out of office</strong>
          </Caption>
        </Grid.Item>
        <Grid.Item size={{ xs: 12 }}>
          <ControlledFormField
            control={control}
            type="switch"
            name="userOutOfOffice"
            id="userOutOfOffice"
            label="Out of office"
            isChecked={currentUserOutOfOffice}
          />
        </Grid.Item>
        {currentUserOutOfOffice && (
          <>
            <Grid.Item size={{ xs: 12, sm: 6 }}>
              <ControlledFormField
                control={control}
                type="date"
                name="oooFromDate"
                id="oooFromDate"
                label="Date from"
              />
            </Grid.Item>
            <Grid.Item size={{ xs: 12, sm: 6 }}>
              <ControlledFormField
                control={control}
                type="date"
                name="oooToDate"
                id="oooToDate"
                label="Date until"
              />
            </Grid.Item>
            <Grid.Item size={{ xs: 12, sm: 6 }}>
              <OooMessageField control={control} />
            </Grid.Item>
          </>
        )}
      </Grid.Container>
    </AccountCard>
  )
}

// Separate component so useWatch for character count doesn't re-render the whole card
const OooMessageField = ({
  control,
}: {
  control: Control<AccountSettingsInputs>
}) => {
  const currentOooMessage = useWatch({ control, name: 'oooMessage' })
  return (
    <ControlledFormField
      control={control}
      type="textarea"
      name="oooMessage"
      id="oooMessage"
      label="Message"
      hintText={characterCount(currentOooMessage, 250)}
    />
  )
}

export default AvailabilityCard
